import { C } from "@/brand/tokens";
import { hero6 } from "@/brand/contentF6";
import { Box6 } from "@/components/common/Box6";
import { Eyebrow6 } from "@/components/common/Eyebrow6";
import { Cta6 } from "@/components/common/Cta6";
import { TextLink6 } from "@/components/common/TextLink6";

/**
 * HeroSection6 — firm-first hero on Deep Mineral Blue.
 * Left: headline, supporting copy, primary + secondary CTA.
 * Right: three boxed proof signals. No founder portrait.
 */
export function HeroSection6() {
  return (
    <section
      id="hero"
      data-testid="hero-6"
      style={{ background: C.surfacePrimary, color: C.textOnDark, borderBottom: `1px solid ${C.brassSoft}` }}
    >
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-10 py-20 lg:py-28">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <Eyebrow6 className="mb-9">{hero6.eyebrow}</Eyebrow6>

            <h1
              data-testid="hero-headline-6"
              className="font-cormorant"
              style={{
                color: C.textOnDark,
                fontSize: "clamp(2.4rem, 5vw, 4.4rem)",
                fontWeight: 400,
                lineHeight: 1.04,
                letterSpacing: "-0.014em",
                maxWidth: "20ch",
              }}
            >
              {hero6.headline}
            </h1>

            <p className="mt-9 font-inter leading-[1.7] max-w-[56ch]" style={{ color: C.whiteOnDark, fontSize: "1.05rem" }}>
              {hero6.subhead}
            </p>

            <div className="mt-12 flex flex-wrap items-center gap-6">
              <Cta6 to={hero6.primaryCta.href} variant="light" testId="hero-primary-cta-6" className="px-7 py-4">
                {hero6.primaryCta.label}
              </Cta6>
              <TextLink6 to={hero6.secondaryCta.href} tone="light" testId="hero-secondary-cta-6">
                {hero6.secondaryCta.label}
              </TextLink6>
            </div>
          </div>

          <div className="lg:col-span-5 lg:pl-6 grid gap-4" data-testid="hero-proof-badges">
            {hero6.proofBadges.map((b, i) => (
              <Box6 as="article" key={b.label} tone="glass" radius="resource" className="p-6 lg:p-7" data-testid={`hero-proof-${i}`}>
                <div className="flex items-baseline gap-4 mb-3">
                  <span
                    className="font-inter text-[10px] uppercase font-bold tabular-nums shrink-0"
                    style={{ color: C.accentMetal, letterSpacing: "0.28em" }}
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <p className="font-inter text-[11px] uppercase font-semibold" style={{ color: C.accentMetal, letterSpacing: "0.24em" }}>
                    {b.label}
                  </p>
                </div>
                <p className="font-inter leading-[1.6]" style={{ color: C.textOnDark, fontSize: "0.95rem" }}>
                  {b.body}
                </p>
              </Box6>
            ))}

            <p
              className="mt-2 pt-4 border-t font-cormorant italic"
              style={{ borderColor: C.brassSoft, color: C.whiteOnDarkSoft, fontSize: "0.95rem" }}
            >
              Confidential by default. Senior throughout.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
